export const FILE_TYPES = ['DOC', 'DOCX', 'PDF', 'JPG', 'PNG', 'ODT'];
export const FILE_MAX_SIZE = '16';
